import React from 'react';
import { Route } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import { history } from 'store';

import { Layout } from 'containers';

import { RouteSwitch } from 'components';

import {
  Start,
  Home,
  Tutorial,
  NotFound
} from 'pages';

const Routes = () => (
  <Layout>
    <ConnectedRouter history={history}>
      <RouteSwitch>
        <Route exact path="/" component={Start} />
        <Route path="/home" component={Home} />
        <Route path="/tutorial" component={Tutorial} />
        <Route path="/not-found" component={NotFound} />
      </RouteSwitch>
    </ConnectedRouter>
  </Layout>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/Routes.js